function LocalStorageService(TestLocalStorage, InMemoryStorage, $window) {
	const storage = TestLocalStorage.isSupported() ? $window.localStorage : InMemoryStorage;
	return storage;
}

module.exports = LocalStorageService;


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/localStorage/local-storage-factory.js
 **/